import { render, staticRenderFns } from "./mensajeDer.vue?vue&type=template&id=a31db514"
import script from "./mensajeDer.vue?vue&type=script&lang=js"
export * from "./mensajeDer.vue?vue&type=script&lang=js"
import style0 from "./mensajeDer.vue?vue&type=style&index=0&id=a31db514&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
